import { CPO_ROUTES } from 'shared/consts/routes/cpo';
import { MenuAddButton } from 'shared/ui/section-menu';

export function AddButton() {
  return (
    <MenuAddButton
      path={CPO_ROUTES.ADD_CPO}
      requiredRights={[
        {
          controller: 'Cpo',
          right: 'Write',
        },
      ]}
    />
  );
}
